// Browser detection utilities
export const isSafari = (): boolean => {
  const ua = navigator.userAgent.toLowerCase();
  const isSafariBrowser = ua.includes('safari') && !ua.includes('chrome') && !ua.includes('android');
  
  // Additional Safari detection for iOS
  const isIOSSafari = /iP(ad|od|hone)/i.test(navigator.userAgent) && 
                      /WebKit/i.test(navigator.userAgent) && 
                      !/(CriOS|FxiOS|OPiOS|mercury)/i.test(navigator.userAgent);
  
  return isSafariBrowser || isIOSSafari;
};

export const isChrome = (): boolean => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('chrome') && !ua.includes('edg');
};

export const isFirefox = (): boolean => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('firefox');
};

// Check if browser has third-party cookie restrictions
export const hasStrictCookiePolicy = (): boolean => {
  // Safari has the strictest policies
  return isSafari();
};

// Get browser-specific storage delay for OAuth processing
export const getOAuthProcessingDelay = (): number => {
  if (isSafari()) {
    // Safari needs more time due to ITP and storage restrictions
    return 500; // 500ms delay for Safari
  }
  return 100; // 100ms for other browsers
};

// Retry storage operation with delays for Safari
export const retryStorageOperation = async <T>(
  operation: () => T | null,
  maxRetries: number = 3,
  delay: number = 100
): Promise<T | null> => {
  for (let i = 0; i < maxRetries; i++) {
    const result = operation();
    if (result !== null) {
      return result;
    }
    
    // Wait before retrying (Safari needs this)
    if (i < maxRetries - 1) {
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }
  return null;
};

// Get browser name for logging
export const getBrowserName = (): string => {
  if (isSafari()) return 'Safari';
  if (isChrome()) return 'Chrome';
  if (isFirefox()) return 'Firefox';
  return 'Unknown';
};